var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgProductIconFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    clipPath: "url(#clip0_3609_24682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 16.5H3C2.80109 16.5 2.61032 16.421 2.46967 16.2803C2.32902 16.1397 2.25 15.9489 2.25 15.75V2.25C2.25 2.05109 2.32902 1.86032 2.46967 1.71967C2.61032 1.57902 2.80109 1.5 3 1.5H15C15.1989 1.5 15.3897 1.57902 15.5303 1.71967C15.671 1.86032 15.75 2.05109 15.75 2.25V15.75C15.75 15.9489 15.671 16.1397 15.5303 16.2803C15.3897 16.421 15.1989 16.5 15 16.5ZM6.75 4.5H5.25V6C5.25 6.99456 5.64509 7.94839 6.34835 8.65165C7.05161 9.35491 8.00544 9.75 9 9.75C9.99456 9.75 10.9484 9.35491 11.6517 8.65165C12.3549 7.94839 12.75 6.99456 12.75 6V4.5H11.25V6C11.25 6.59674 11.0129 7.16903 10.591 7.59099C10.169 8.01295 9.59674 8.25 9 8.25C8.40326 8.25 7.83097 8.01295 7.40901 7.59099C6.98705 7.16903 6.75 6.59674 6.75 6V4.5Z",
    fill: "#77CCEE"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 49",
    x: 7,
    y: 11,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#FDFDFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3609_24682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProductIconFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ProductIconFilled.88037367.svg";
export { ForwardRef as ReactComponent };